import { useEffect, useState } from "react";
import { Button, Modal, ListGroup } from "react-bootstrap";
import "./prePrintedLabels.css";
import { getReturnOrder } from "../../../../store/api/apiSlice";
import { useAppDispatch } from "../../../../store/hooks";

interface Props {
  orderid: string;
  show: boolean;
  handleClose: () => void;
}

interface ArsTrackingItem {
  ID: string;
  CUSTRECORD_ARS_TRACKING_NUMBER: string;
}

function PrePrintedLabelsSubmittedModal({
  orderid,
  show,
  handleClose,
}: Props) {
  const dispatch = useAppDispatch();
  const [arsTracking, setArsTracking] = useState<ArsTrackingItem[]>([]);

  useEffect(() => {
    if (show && orderid) {
      dispatch(getReturnOrder(orderid)).then((result: any) => {
        const prePrintedLabels = result?.payload?.data?.prePrintedLabels ?? [];

        const mappedItems: ArsTrackingItem[] = prePrintedLabels.map(
          (item: any) => ({
            ID: String(item.returnOrderId),
            CUSTRECORD_ARS_TRACKING_NUMBER: item.arsTracking,
          })
        );
       
        setArsTracking(mappedItems);
      });
    }
  }, [show, orderid, dispatch]);

  return (
    <Modal
      show={show}
      centered={true}
      dialogClassName="modal-60w"
      className="custom_modal fixed-height-modal"
      onHide={handleClose}
    >
      <Modal.Header className="custom_modal_header">
        <Modal.Title className="custom_modal_header_title">
          <div className="custom_modal_header_title_left">Pre-printed Labels</div>
          <div className="custom_modal_header_title_right">
            <Button variant="link" onClick={handleClose}>
              <i className="fa-solid fa-times"></i>
            </Button>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom_modal_body">
        <ListGroup className="mt-3 scrollableList">
          {arsTracking.map((item) => (
            <ListGroup.Item
              key={item.ID}
              className="d-flex justify-content-between align-items-center"
            >
              {item.CUSTRECORD_ARS_TRACKING_NUMBER}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
}

export default PrePrintedLabelsSubmittedModal;
